import { render, staticRenderFns } from "./LoginNewDesign.vue?vue&type=template&id=93993c8a&scoped=true"
import script from "./LoginNewDesign.vue?vue&type=script&lang=js"
export * from "./LoginNewDesign.vue?vue&type=script&lang=js"
import style0 from "./LoginNewDesign.vue?vue&type=style&index=0&id=93993c8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93993c8a",
  null
  
)

export default component.exports